<template>
  <div class="section">
    <h1>Contact</h1>
    <div id="left-side">
      <a href="https://www.linkedin.com/in/mackenzie-frey/" target="_blank">
        <img alt="linkedin logo" src="@/assets/logo_linkedin.svg" id="linkedin">
      </a>
      <a href="https://github.com/Mackenzie-Frey" target="_blank">
        <img alt="github logo" src="@/assets/logo_github_black.png" id="github">
      </a>
    </div>
    <div id="right-side">
      Email Form
      <EmailForm></EmailForm>
    </div>
  </div>
</template>

<script>
import EmailForm from '@/components/EmailForm.vue'

export default {
  components: {
    EmailForm
  }
}
</script>

<style scoped>

img {
  max-width: 15%;
  height: auto;
  display: block;
  margin: auto;
  padding: 2%;
}


#left-side {
  float: left;
  width: 50%;
  height: 45%;
}

#right-side {
  float: right;
  width: 50%;
  height: 45%;
}

</style>
